// extracted by mini-css-extract-plugin
var _1 = "bxOzD5t3ps81PnyuJt4R";
var _2 = "lET7RvC1kM1PHFqT01nQ";
export { _1 as "block", _2 as "root" }
export default { "block": _1, "root": _2 }
